import PropTypes from 'prop-types';
import ProfitShareRevenue from './components/profit-share/ProfitShareRevenue';
import DaysInQuarter from './components/profit-share/DaysInQuarter';
import SummaryWithUtil from './components/profit-share/SummaryWithUtil';
import TotalCosts from './components/profit-share/TotalCosts';
import NetProfitAndLoss from './components/profit-share/NetProfitAndLoss';
import ProfitShareFees from './components/profit-share/ProfitShareFees';
import RentPaidSeparately from './components/profit-share/RentPaidSeparately';

const PsBasicRentOnly = ({statement}) => {
  return (
    <div>
      <DaysInQuarter liveDaysInQ={statement.data.liveDaysInQ} />
      <SummaryWithUtil data={statement.data}/>
      <ProfitShareRevenue data={statement.data}/>
      <ProfitShareFees data={statement.data} />
      <RentPaidSeparately data={statement.data} />
      <TotalCosts totalCosts={statement.data.totalCosts}/>
      <NetProfitAndLoss netProfitLossForPeriod={statement.data.netProfitLossForPeriod}/>
    </div>
  )
}

export default PsBasicRentOnly;

PsBasicRentOnly.propTypes = {
  statement: PropTypes.object.isRequired,
};